import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const formConfig = {
    formConfig :{
        BSTKD_E:'',
        form_class: 'base_form',
        loading:false,
        formError:'',
        body: [
            {index: 1, body_class: 'q-gutter-sm row items-start',
                items:[
                    {index: 1, label: '订单编号',labelWidth:110, showlabel: true, name: 'BSTKD_E',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    {index: 2, label: '订货人',labelWidth:110, showlabel: true, name: 'KUNNR',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    {index: 3, label: '订单日期',labelWidth:110, showlabel: true, name: 'BSTDK',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    {index: 4, label: '报价单号',labelWidth:110, showlabel: true, name: 'VBELN',value: '', type: 'input', filled:false, outlined: true, disable:false, variant:{auto_assignment: true},minWidth: 160},
                    {index: 5, label: '收货人',labelWidth:110, showlabel: true, name: 'KGNNR',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    // {index: 6, label: '订单/报价单类型',labelWidth:110, showlabel: true, name: 'AUART',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    // {index: 7, label: '特折号',labelWidth:110, showlabel: true, name: 'BSTKD',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    // {index: 8, label: '三方协议号',labelWidth:110, showlabel: true, name: 'ZZPROM',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    {index: 9, label: '发送状态',labelWidth:110, showlabel: true, name: 'is_send',value: '', type: 'select',variant:{options:[{label: '已发送', value:true},{label: '未发送', value:false}]}, filled:false,disable:true, outlined: true,minWidth: 160},
                    // {index: 10, label: '状态码',labelWidth:110, showlabel: true, name: 'CODE',value: '', type: 'input', filled:false, outlined: true, disable:true,minWidth: 160,variant:{auto_assignment: true}},
                    // {index: 11, label: '预付款标志',labelWidth:110, showlabel: true, name: 'DPFLAG',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                    {index: 11, label: '提示消息',labelWidth:110, showlabel: true, name: 'MESSAGE',value: '', type: 'input', filled:false, outlined: true, disable:true, variant:{auto_assignment: true},minWidth: 160},
                ]},
        ]}
}
const tableData = {
    tableData:{
        tableName:'send-purchase-order',
        falsePagination:true,
        loading:false,
        isFullscreen:false,
        selection: 'multiple',
        showSelection:true,
        height:'',
        selected: [],
        data: [],
        count: 0,
        rowkey:'FEntryID',
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 0, page: 1, search:'' },
        tools: {
            show_toolbar: true,
            btns: [
                { index: 1, name: ['匹配'], icon: 'fas fa-crop-alt', check_lines: 0, on_click: [], sign: 'match', },
                { index: 0, name: ['发送'], icon: 'fas fa-paper-plane', check_lines: 0, on_click: [], sign: 'send', },
            ]
        },
        columns: [
            {name: 'FEntryID', field: 'FEntryID',label: '客户采购订单行号', align: 'left',sortable: true},
            {name: 'F_SPRLine', field: 'F_SPRLine',label: '施耐德报价单行号', align: 'left',sortable: true},
            {name: 'EDATU', field: 'EDATU',label: '客户期望交货日期', align: 'left',sortable: true},
            {name: 'MaterialName', field: 'MaterialName',label: '物料名称', align: 'left',sortable: true},
            {name: 'KWMENG', field: 'KWMENG',label: '数量', align: 'right',sortable: true},
            {name: 'MATNR', field: 'MATNR',label: '订货号', align: 'left',sortable: true},
            {name: 'FModel', field: 'FModel',label: '规格型号', align: 'left',sortable: true},
            {name: 'FTaxRate', field: 'FTaxRate',label: '折扣率', align: 'right',sortable: true},
            {name: 'FAuxPriceDiscount', field: 'FAuxPriceDiscount',label: '实际含税单价', align: 'right',sortable: true},
            {name: 'FCess', field: 'FCess',label: '税率', align: 'right',sortable: true},
            {name: 'MWSTI', field: 'MWSTI',label: '税额', align: 'right',sortable: true},
            {name: 'FAllAmount', field: 'FAllAmount',label: '价税合计', align: 'right',sortable: true},
        ]
    }
};
const state = () => ({
    sendPurchaseOrder: Object.assign({}, tableData,formConfig),
})
const getters = {
    getFormConfig: state => state.sendPurchaseOrder.formConfig,
    getTableData: state => state.sendPurchaseOrder.tableData,
}
const mutations ={
    clearFormError(state, data){
        state.sendPurchaseOrder.formConfig.formError = '';
    },
    setLoading(state, data){
        state.sendPurchaseOrder.tableData.loading = data;
        state.sendPurchaseOrder.formConfig.loading = data;
    },
    setErrorData(state, data){
        state.sendPurchaseOrder.formConfig.formError = data;
    },
    setData(state, data) {
        state.sendPurchaseOrder.formConfig.body[0].items.forEach(item=>{
            if(isNotEmpty(data.HEADER[item.name])){
                item.value = (data.HEADER[item.name]+'').trim();
            }else{
                item.value = '';
            }
        });
        state.sendPurchaseOrder.tableData.data = data.ITEM;
        state.sendPurchaseOrder.tableData.pagination.rowsNumber = data?.ITEM?.length || 0;
    },
    setTableData(state, data) {
        state.sendPurchaseOrder.tableData.data = data;
        state.sendPurchaseOrder.tableData.pagination.rowsNumber = data?.length || 0;
    },
    ['refreshTableHeight'](state, data) {
        state.sendPurchaseOrder.tableData.height = (data-55) + 'px';

    },
    ['clearData'](state, data) {

    }
}
const actions = {
    ['return_send_data']({ state, commit,dispatch }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            commit('setErrorData','');
            dispatch('response/success-tip', { message: '发送采购订单成功！' }, { root: true })
        }else{
            commit('setErrorData',payload.errors)
        }
        dispatch('fetch-page-init',{BSTKD_E:state.sendPurchaseOrder.formConfig.BSTKD_E})
    },
    ['fetch-send']({ state, dispatch, rootState ,commit}, payload) {
        commit('setErrorData','')
        if(state.sendPurchaseOrder.formConfig.loading) return;
        commit('setLoading',true);
        let msg = { command: "post_client__erp_purchase_send", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['fetch-reg_data']({ state, dispatch, rootState ,commit}, payload) {
        commit('setErrorData','')
        if(state.sendPurchaseOrder.formConfig.loading) return;
        commit('setLoading',true);
        let msg = { command: "post_client__erp_reg_data", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['return_reg_data']({ state,dispatch, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            dispatch('response/success-tip', { message: '匹配成功！' }, { root: true })
            commit('setErrorData','')
            commit('setTableData',payload.data.data);
        }else{
            commit('setErrorData',payload.errors)
        }
    },
    async ['fetch-page-init']({ state, dispatch, rootState ,commit}, payload) {
        if(!isNotEmpty(payload['BSTKD_E'])){
            return
        }
        if(state.sendPurchaseOrder.formConfig.loading) return;
        commit('setLoading',true);
        state.sendPurchaseOrder.formConfig.BSTKD_E = payload.BSTKD_E;
        let msg = { command: "post_client__erp_purchase_init", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_data']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            commit('setData',payload.data);
            let myCoums = await getMyColums({name:state.sendPurchaseOrder.tableData.tableName});//获取偏好
            setNowTabPageCongfig({pageConfig:state.sendPurchaseOrder.tableData,myColums:myCoums})//设置为自己的偏好
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
